import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
  Modal,
  Spinner,
} from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { DownloadCloud, RefreshCcw, Bell, Clock, LogOut, User, Printer, FileText, Search, PlusCircle, Trash2 } from "react-feather";
import AsyncSelect from "react-select/async";
import ReactToPrint from "react-to-print";

import { getAppointments, getCustomers, searchInventoryItems } from "../../../Data/Customer/api";
import { fetchSignedUrls } from "../../utils/fileUtils";
import FileUpload from "../../SubComponents/FileUpload";
import PrintComponent from "./PrintComponent";
import PrescriptionActions from "./PriscriptionActions";

// Framer Motion presets
const containerVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4, ease: "easeOut", staggerChildren: 0.1 }
  }
};

const Treatment = () => {
  const token = JSON.parse(sessionStorage.getItem("token"));
  const auth = useSelector((state) => state.authentication);
  const { userData, branchData } = auth;
  const branch = JSON.parse(sessionStorage.getItem("branch"));
  
  const location = useLocation();
  const locationState = location.state;

  // Doctor & Branding Resolution
  const doctorName = userData?.user || userData?.name || "Doctor";
  const logoUrl = branchData?.[0]?.logo || branch?.logo || null;
  
  const navigate = useNavigate();
  const componentRef = useRef();

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const toggleSearchModal = () => setSearchModalOpen(!searchModalOpen);
  
  const [selectedDate, setSelectedDate] = useState(new Date());
  const date = new Date(selectedDate);
  const withoutTime = new Date(date.setHours(0, 0, 0, 0));

  const [customerData, setCustomerData] = useState([]);
  const [diagnosis, setDiagnosis] = useState("");
  const [specialAdvice, setSpecialAdvice] = useState("");
  const [address, setAddress] = useState("");
  const [printEnable, setprintEnable] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedCm, setSelectCm] = useState(null);
  const [customerHistory, setCustomerHistory] = useState([]);
  const [mHeader, setMHeader] = useState("Patient List");
  const [selectedAppointment, setSelectedAppointment] = useState([]);
  const [saved, setSaved] = useState(false);
  const [complaintsnHistory, setComplaintsnHistory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [formData, setFormData] = useState({});
  const [savedPrescription, setSavedPrescription] = useState(null);

  // Manual Patient Fields (when no patient is selected)
  const [manualPatient, setManualPatient] = useState({
    name: "",
    age: "",
    contactno: "",
   sex: "",
  });

  // Integrated Medicine Item Array
  const [prescribedMedications, setPrescribedMedications] = useState([]);
  const [selectedMedSearch, setSelectedMedSearch] = useState(null);

  const computedPrescription = prescribedMedications
    .map((m) => m.medicine?.label || "Custom Instruction")
    .join(", ");
  const computedPrescriptionNotes = prescribedMedications
    .map(
      (m) =>
        `${m.medicine?.label || "Note"}: [${m.dosage || "-"}] [${m.timing || "-"}] ${
          m.customNotes ? `- ${m.customNotes}` : ""
        }`
    )
    .join("\n");

  const [printData, setPrintData] = useState({});

  const formatDateForInput = (d) => {
    return d ? new Date(d).toISOString().split("T")[0] : "";
  };

  const getCustomerHandler = (newDate) => {
    const d = new Date(newDate);
    const withoutTimenew = new Date(d.setHours(0, 0, 0, 0));
    processAppointments(token, withoutTimenew, branch, doctorName);
  };

  const processAppointments = async (token, withoutTimenew, branch, doctorName) => {
    try {
      const appointments = await getAppointments(token, withoutTimenew, branch, "", doctorName, "", navigate);
      setSelectedAppointment(() => appointments.filter((item) => !item.mrn.includes("Tmp")));
      const mrns = appointments.map((appointment) => appointment.mrn);
      const customerDataPromises = mrns.map((mrn) => getCustomers(token, branch, mrn, "", "", navigate).then((res) => res));
      const customerDataArray = await Promise.all(customerDataPromises);
      setCustomerData(customerDataArray.flat());
    } catch (error) {
      console.error("Error fetching patient queue:", error);
    }
  };

  useEffect(() => {
    if (branchData && branchData.length > 0) {
      const { first_line, second_line, third_line, fourth_line } = branchData[0].address || {};
      setAddress({ first_line, second_line, third_line, fourth_line });
    }
  }, [branchData]);

  // Load customer details via location state or saved MRN if returning from another form
  useEffect(() => {
    const targetMrn = locationState?.mrn || JSON.parse(sessionStorage.getItem("savedMrn") || sessionStorage.getItem("srchData")?.mrn || null);
    if (targetMrn && token && branch) {
      getCustomers(token, branch, targetMrn, "", "", navigate)
        .then((res) => {
          if (res && res.length > 0) {
            setSelectCm(res[0]);
          }
        })
        .catch((err) => console.error("Error loading patient by MRN:", err));
    }
  }, [locationState, token, branch]);

  const clearFom = () => {
    setPrescribedMedications([]);
    setSpecialAdvice("");
    setDiagnosis("");
    setComplaintsnHistory("");
    setPrintData({});
    setManualPatient({ name: "", age: "", contactno: "",sex: "" });
  };

 // const handleAddMedicine = (selectedOption) => {
 //   if (!selectedOption) return;
 //   setPrescribedMedications((prev) => [
 //     ...prev,
 //     {
 //       id: Date.now(),
 //       medicine: selectedOption,
 //       dosage: "1-0-1",
 //       timing: "After Food",
 //       customNotes: "",
 //     },
 //   ]);
 //   setSelectedMedSearch(null);
 //   setSaved(false);
 // };

 const handleAddMedicine = (selectedOption) => {
  if (!selectedOption) return;

  const medicineName =
    typeof selectedOption === "string"
      ? selectedOption
      : selectedOption.label || selectedOption.medicine || "";

  const isInjection = medicineName.toLowerCase().includes("inj");

  setPrescribedMedications((prev) => [
    ...prev,
    {
      id: Date.now(),
      medicine: selectedOption,
      dosage: isInjection ? "" : "1-0-1",
      timing: isInjection ? "" : "After Food",
      customNotes: "",
    },
  ]);

  setSelectedMedSearch(null);
  setSaved(false);
};

  const handleAddCustomLine = () => {
    setPrescribedMedications((prev) => [
      ...prev,
      {
        id: Date.now(),
        medicine: { label: "Custom Line", value: "custom" },
        dosage: "",
        timing: "",
        customNotes: "",
      },
    ]);
    setSaved(false);
  };

  const handleUpdateMedicine = (index, field, value) => {
    setPrescribedMedications((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
    setSaved(false);
  };

  const handleRemoveMedicine = (index) => {
    setPrescribedMedications((prev) => prev.filter((_, i) => i !== index));
    setSaved(false);
  };

  const postData = {
    mrn: selectedCm ? selectedCm.mrn : "WALK-IN-" + Date.now(),
    patientName: selectedCm ? `${selectedCm.fname} ${selectedCm.sname}` : manualPatient.name,
    age: selectedCm ? selectedCm.age : manualPatient.age,
    contactno: selectedCm ? selectedCm.contactno : manualPatient.contactno,
    sex: selectedCm ? selectedCm.sex : manualPatient.sex,
    branch,
    date: withoutTime,
    fullDate: new Date(),
    doctorName,
    diagnosis,
    prescription: computedPrescription,
    prescriptionNotes: computedPrescriptionNotes,
    prescribedMedications,
    specialAdvice,
    complaintsnHistory,
    ...formData,
  };

  const getCustomerHistory = () => {
    if (!selectedCm || !selectedCm.mrn) return;
    setIsLoadingHistory(true);
    axios
      .get(`${process.env.REACT_APP_CRI_API}prescript`, {
        params: { branch, doctorName, mrn: selectedCm.mrn },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.status === 200) {
          setCustomerHistory(res.data);
        }
      })
      .then(() => {
        setMHeader("Patient History");
        setIsLoadingHistory(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response?.data && (err.response.data.err?.name === "TokenExpiredError" || err.response.data.message === "Unauthorized")) {
          sessionStorage.clear();
          navigate("/cri-crm");
        }
      });
  };

  const buildPrintPayload = (overrideData = {}) => {
    const activePatientInfo = selectedCm ? {
      ...selectedCm,
      customerData: selectedCm,
      patientName: `${selectedCm.fname || ""} ${selectedCm.sname || ""}`,
      contactno: selectedCm.contactno,
    } : {
      patientName: manualPatient.name,
      age: manualPatient.age,
      contactno: manualPatient.contact,
     sex: manualPatient.sex,
    };

    return {
      ...activePatientInfo,
      doctorName,
      username: doctorName,
      userData,
      branch: branchData?.[0] || branch,
      date: withoutTime,
      fullDate: new Date(),
      complaintsnHistory,
      diagnosis,
      prescription: computedPrescription,
      prescriptionNotes: computedPrescriptionNotes,
      prescribedMedications,
      specialAdvice,
      ...overrideData,
    };
  };

  const submitHandler = () => {
    if (!formData.files && !window.confirm("Do you want to continue saving without file upload?")) {
      return;
    }
    if (saved) {
      alert("Already Saved");
      return;
    }
    if (prescribedMedications.length === 0 && !diagnosis) {
      alert("Kindly enter Diagnosis and Prescribed Medicines");
      return;
    }
// Validation for Manual Patient Entries (Name, Age, sex are must)
    if (!selectedCm) {
      if (!manualPatient.name || !manualPatient.name.trim()) {
        alert("Patient Name is required");
        return;
      }
      if (manualPatient.age === undefined || manualPatient.age === null || String(manualPatient.age).trim() === "") {
        alert("Patient Age is required");
        return;
      }
      if (!manualPatient.sex || !manualPatient.sex.trim()) {
        alert("Patient sex is required");
        return;
      }
  
    }

    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_CRI_API}add-prescript`, postData, {
        params: { branch, doctorName },
        headers: { Authorization: `Bearer ${token}` },
      })
     .then((res) => {
        if (res.status === 200) {
          setPrintData(buildPrintPayload(res.data));
          setSavedPrescription(res.data); // 👈 Save response data here
          alert("Save Successful");
          setprintEnable(true);
          if (selectedCm) {
            getCustomerHistory();
          }
          setSaved(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
        if (err.response?.data && (err.response.data.err?.name === "TokenExpiredError" || err.response.data.message === "Unauthorized")) {
          sessionStorage.clear();
          navigate("/cri-crm");
        }
      });
  };

  const selectCmHandler = (cm) => {
    setSelectCm(cm);
    sessionStorage.setItem("savedMrn", JSON.stringify(cm.mrn));
    toggle();
  };

  const loadMedOptions = async (inputValue, callback) => {
    try {
      const response = await searchInventoryItems(token, inputValue, branch, navigate);
      const seenLabels = new Set();
      const options = response
        .map((item) => ({ value: item._id, label: item.item }))
        .filter((option) => {
          if (!option.label || seenLabels.has(option.label)) return false;
          seenLabels.add(option.label);
          return true;
        });
      callback(options);
    } catch (error) {
      console.error("Error fetching options:", error);
      callback([]);
    }
  };

  const formatDisplayDate = (d) => {
    if (!d) return "--/--/----";
    const dateObj = new Date(d);
    return `${String(dateObj.getDate()).padStart(2, "0")}/${String(dateObj.getMonth() + 1).padStart(2, "0")}/${dateObj.getFullYear()}`;
  };

  const formatDisplayTime = (d) => {
    if (!d) return "--:-- AM";
    const dateObj = new Date(d);
    return dateObj.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
  };

  return (
    <Container fluid className="py-4 bg-light min-vh-100">
      {/* Hidden Print Wrapper */}
      <div style={{ display: "none" }}>
        <PrintComponent 
          ref={componentRef} 
          branch={branchData?.[0] || branch} 
          data={printData} 
          logoUrl={logoUrl} 
        />
      </div>

      <motion.div variants={containerVariants} initial="hidden" animate="visible">
        <Card className="border-0 shadow-sm rounded-3 overflow-hidden mb-4">
          <Card.Header className="bg-primary text-white p-4 d-flex flex-wrap justify-content-between align-items-center border-0 gap-3">
            <div className="d-flex align-items-center gap-3">
              <div className="bg-white bg-opacity-25 p-2.5 rounded-3">
                <FileText size={28} />
              </div>
              <div>
                <h4 className="mb-0 fw-bold">Clinical Desk & Prescriptions</h4>
                <span className="text-white text-opacity-75 small">Comprehensive Treatment Interface</span>
              </div>
            </div>
            <div className="bg-white bg-opacity-10 px-3 py-2 rounded-3 border border-white border-opacity-10 d-flex align-items-center gap-2">
              <User size={16} className="text-white text-opacity-75" />
              <div>
                <span className="d-block small text-white text-opacity-50">Doctor</span>
                <strong className="text-white">{doctorName}</strong>
              </div>
            </div>
          </Card.Header>

          <Card.Body className="p-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4 bg-light p-3 rounded-3 border">
              <div className="d-flex flex-wrap gap-2">
                <Button variant="primary" onClick={toggleSearchModal} className="shadow-sm d-flex align-items-center gap-2 px-3 rounded-3">
                  <Search size={16} /> Search Patient System
                </Button>
                <Button variant="outline-primary" onClick={() => navigate("/otBooking")} className="px-3 rounded-3 bg-white">
                  Appointment Desk
                </Button>
                <Button variant="outline-primary" onClick={() => navigate("/lab-admin")} className="px-3 rounded-3 bg-white">
                  Laboratory Desk
                </Button>
                <Button variant="outline-primary" onClick={() => navigate("/sku")} className="px-3 rounded-3 bg-white">
                  Medicine Stock
                </Button>
                 <Button variant="outline-primary" onClick={() => navigate("/customer_form")} className="px-3 rounded-3 bg-white">
                  Patient Form
                </Button>
              </div>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2 px-3 rounded-3 bg-white"
                onClick={() => {
                  sessionStorage.clear();
                  navigate("/cri-crm");
                }}
              >
                <LogOut size={16} /> Terminate Session
              </Button>
            </div>

            <div className="d-flex align-items-center gap-2 mb-4">
              <Button
                variant="primary"
                size="md"
                className="d-flex align-items-center gap-2 px-4 shadow-sm"
                onClick={() => {
                  getCustomerHandler(selectedDate);
                  toggle();
                  setMHeader("Patient List");
                }}
              >
                <Bell size={16} /> Active Allocations
                <Badge bg="light" className="text-primary rounded-pill px-2 py-0.5 ms-1">
                  {selectedAppointment ? selectedAppointment.length : 0}
                </Badge>
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                className="p-2 bg-white rounded-circle border shadow-sm d-flex align-items-center justify-content-center"
                onClick={() => getCustomerHandler(selectedDate)}
              >
                <RefreshCcw size={15} />
              </Button>

              {selectedCm && (
                <Button
                  variant="outline-secondary"
                  className="ms-auto d-flex align-items-center gap-2 bg-white px-3"
                  onClick={() => {
                    getCustomerHistory();
                    toggle();
                    setMHeader("Patient History");
                  }}
                >
                  <Clock size={16} /> Historical Manifest
                  <Badge bg="secondary" className="rounded-pill px-2 py-0.5">
                    {customerHistory ? customerHistory.length : 0}
                  </Badge>
                </Button>
              )}
            </div>

            <Row className="g-4">
              <Col lg={3} md={12}>
                <AnimatePresence mode="wait">
                  {selectedCm ? (
                    <motion.div key="profile-selected" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.2 }}>
                      <Card className="border border-light shadow-sm rounded-3 h-100 bg-white">
                        <Card.Header className="bg-light py-3 border-bottom border-light d-flex justify-content-between align-items-center">
                          <div>
                            <h5 className="mb-0 fw-bold text-dark">{selectedCm.fname} {selectedCm.sname}</h5>
                            <small className="text-muted text-monospace d-block mt-0.5">{selectedCm.mrn}</small>
                          </div>
                          <Button variant="outline-danger" size="sm" className="py-0 px-2" onClick={() => setSelectCm(null)} title="Clear Patient">
                            &times;
                          </Button>
                        </Card.Header>
                        <Card.Body className="p-3 small text-secondary">
                          <div className="mb-3 d-flex flex-wrap gap-3 border-bottom pb-2">
                            <div><strong>sex:</strong> <span className="text-dark d-block">{selectedCm.sex || "—"}</span></div>
                            <div><strong>DOB:</strong> <span className="text-dark d-block">{selectedCm.dob || "—"}</span></div>
                            <div><strong>Age:</strong> <span className="text-dark d-block">{selectedCm.age || "—"}</span></div>
                          </div>
                          <div className="space-y-2">
                            <p className="mb-2"><strong>Target Protocol:</strong><span className="text-dark d-block mt-0.5 bg-light p-2 rounded">{selectedCm.treatmenttype || "—"}</span></p>
                            <p className="mb-2"><strong>Past Formulations:</strong><span className="text-dark d-block mt-0.5">{selectedCm.pastPrescription || "—"}</span></p>
                            <p className="mb-2"><strong>Hypersensitivity Profile:</strong><span className="text-danger fw-medium d-block mt-0.5 bg-danger bg-opacity-10 p-2 rounded border border-danger border-opacity-10">{selectedCm.reactionAlergies || "No Known Allergies"}</span></p>
                            <p className="mb-2"><strong>Clinical Coordinator:</strong><span className="text-dark d-block mt-0.5">{selectedCm.patientcoordinator || "—"}</span></p>
                            <p className="mb-0"><strong>Operational Remarks:</strong><span className="text-muted d-block mt-0.5 italic">{selectedCm.remarks || "—"}</span></p>
                          </div>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  ) : (
                    <motion.div key="profile-empty" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                      <Card className="border border-dashed shadow-sm rounded-3 h-100 bg-white p-3">
                        <h6 className="fw-bold text-dark mb-3">Manual Patient Entry</h6>
                        <Form className="d-flex flex-column gap-2 small">
                          <Form.Group>
                            <Form.Label className="mb-1 text-secondary">Patient Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              placeholder="Full Name"
                              value={manualPatient.name}
                              onChange={(e) => {
                                setManualPatient({ ...manualPatient, name: e.target.value });
                                setSaved(false);
                              }}
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="mb-1 text-secondary">Age <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              placeholder="Age"
                              value={manualPatient.age}
                              onChange={(e) => {
                                setManualPatient({ ...manualPatient, age: e.target.value });
                                setSaved(false);
                              }}
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="mb-1 text-secondary">Mobile No</Form.Label>
                            <Form.Control
                              size="sm"
                              type="text"
                              placeholder="Mobile Number"
                              value={manualPatient.contactno}
                              onChange={(e) => {
                                setManualPatient({ ...manualPatient, contactno: e.target.value });
                                setSaved(false);
                              }}
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="mb-1 text-secondary">sex <span className="text-danger">*</span></Form.Label>
                            <Form.Select
                              size="sm"
                              value={manualPatient.sex}
                              onChange={(e) => {
                                setManualPatient({ ...manualPatient,sex: e.target.value });
                                setSaved(false);
                              }}
                            >
                              <option value="">Select sex</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </Form.Select>
                          </Form.Group>
                        </Form>
                      </Card>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Col>

              <Col lg={9} md={12}>
                <Card className="border border-light shadow-sm rounded-3 bg-white">
                  <Card.Header className="d-flex align-items-center justify-content-between bg-light py-3 px-4 border-bottom flex-wrap gap-3">
                    <h5 className="mb-0 fw-bold text-dark">Clinical Workspace Input Matrix</h5>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <div className="d-flex align-items-center gap-2">
                        <Form.Label className="mb-0 text-secondary small fw-medium text-nowrap">Session Tracking Date:</Form.Label>
                        <Form.Control
                          type="date"
                          size="sm"
                          className="border shadow-sm rounded-3"
                          style={{ width: "160px" }}
                          value={selectedDate ? formatDateForInput(selectedDate) : ""}
                          onChange={(e) => {
                            if (!e.target.value) {
                              setSelectedDate(null);
                              return;
                            }
                            const newDate = new Date(e.target.value);
                            setSelectedDate(newDate);
                            getCustomerHandler(newDate);
                          }}
                        />
                      </div>
                      <div className="text-end border-start ps-3 border-secondary border-opacity-20 d-none d-sm-block small">
                        <span className="text-muted d-block small">Consultation Timestamp</span>
                        <strong className="text-dark">{formatDisplayDate(selectedDate)} — {formatDisplayTime(selectedDate)}</strong>
                      </div>
                    </div>
                  </Card.Header>

                  <Card.Body className="p-4">
                    <Row className="g-3">
                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-secondary small mb-1">1. Subjective Complaints & Medical History</Form.Label>
                          <Form.Control as="textarea" rows={2} className="p-2.5 rounded-3 shadow-sm border" value={complaintsnHistory} onChange={(e) => { setComplaintsnHistory(e.target.value); setSaved(false); }} />
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-secondary small mb-1">2. Clinical Diagnosis Parameters</Form.Label>
                          <Form.Control as="textarea" rows={2} className="p-2.5 rounded-3 shadow-sm border" value={diagnosis} onChange={(e) => { setDiagnosis(e.target.value); setSaved(false); }} />
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <div className="border rounded-3 p-3 bg-light bg-opacity-50 shadow-sm">
                          <Form.Label className="fw-semibold text-secondary small mb-2 d-flex justify-content-between align-items-center">
                            <span>3. Integrated Pharmacotherapy Prescriber</span>
                            <Button variant="outline-primary" size="sm" className="py-1 px-2.5 rounded-2 d-flex align-items-center gap-1 bg-white" onClick={handleAddCustomLine}>
                              <PlusCircle size={14} /> Add Custom Line
                            </Button>
                          </Form.Label>

                          <div className="mb-3">
                            <AsyncSelect
                              cacheOptions
                              defaultOptions
                              loadOptions={loadMedOptions}
                              value={selectedMedSearch}
                              onChange={handleAddMedicine}
                              placeholder="Type medicine name to add (e.g. Paracetamol, Amoxicillin)..."
                              className="shadow-sm rounded-3 border-0 text-secondary"
                            />
                          </div>

                          {prescribedMedications.length > 0 && (
                            <div className="d-flex flex-column gap-2">
                              {prescribedMedications.map((item, index) => (
                                <div key={item.id} className="p-2.5 rounded-3 border bg-white shadow-sm d-flex flex-wrap align-items-center gap-2">
                                  <span className="fw-bold text-primary px-2.5 py-1 bg-primary bg-opacity-10 border rounded-2" style={{ minWidth: "160px", maxWidth: "220px" }}>
                                    {item.medicine?.label || "Custom Line"}
                                  </span>
                                  <Form.Control size="sm" type="text" placeholder="Dosage (1-0-1)" value={item.dosage} onChange={(e) => handleUpdateMedicine(index, "dosage", e.target.value)} style={{ width: "110px" }} className="rounded-2" />
                                  <Form.Select size="sm" value={item.timing} onChange={(e) => handleUpdateMedicine(index, "timing", e.target.value)} style={{ width: "130px" }} className="rounded-2">
                                    <option value="After Food">After Food</option>
                                    <option value="Before Food">Before Food</option>
                                    <option value="At Bedtime">At Bedtime</option>
                                    <option value="As Needed">As Needed</option>
                                  </Form.Select>
                                  <Form.Control size="sm" type="text" placeholder="Special Note (e.g. 5 days)" value={item.customNotes} onChange={(e) => handleUpdateMedicine(index, "customNotes", e.target.value)} className="flex-grow-1 rounded-2" />
                                  <Button variant="outline-danger" size="sm" className="p-1 border-0 rounded-circle" onClick={() => handleRemoveMedicine(index)}>
                                    <Trash2 size={16} />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label className="fw-semibold text-secondary small mb-1">4. Special Directives & Advice</Form.Label>
                          <Form.Control as="textarea" rows={2} className="p-2.5 rounded-3 shadow-sm border" value={specialAdvice} onChange={(e) => { setSpecialAdvice(e.target.value); setSaved(false); }} />
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <FileUpload onUpload={(files) => setFormData((prev) => ({ ...prev, files }))} />
                      </Col>

                      <Col xs={12} className="pt-2 d-flex gap-2">
                        <Button variant="primary" disabled={isLoading} className="px-4 shadow-sm" onClick={submitHandler}>
                          {isLoading ? <Spinner animation="border" size="sm" /> : "Save Prescription"}
                        </Button>
                       <PrescriptionActions
                          prescription={savedPrescription} // 👈 Pass saved response with _id
                          branch={branch}
                          token={token}
                          branchData={branchData}
                          address={address}
                          contactNo={savedPrescription?.contactno || selectedCm?.contactno || manualPatient.contactno}
                        />
                        <ReactToPrint
                          onBeforeGetContent={() => {
                            setPrintData(buildPrintPayload());
                            return new Promise((resolve) => setTimeout(resolve, 100));
                          }}
                          trigger={() => (
                            <Button variant="outline-secondary" className="px-4 bg-white border shadow-sm d-flex align-items-center gap-2">
                              <Printer size={16} /> Print Prescription
                            </Button>
                          )}
                          content={() => componentRef.current}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </motion.div>

      {/* Search Patient Database Modal */}
      <Modal show={searchModalOpen} onHide={toggleSearchModal} size="lg" centered>
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="fw-bold">Search Patient Database</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={async (inputValue, callback) => {
              if (!inputValue) {
                callback([]);
                return;
              }
              try {
                const response = await axios.get(`${process.env.REACT_APP_CRI_API}searchcustomers`, {
                  params: {
                    branch: branch,
                    search: inputValue,
                  },
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
                const res = response.data || [];
                const options = res.map((item) => ({
                  value: item.mrn,
                  label: `${item.fname} ${item.sname} (${item.mrn}) - ${item.contactno || "No Contact"}`,
                  customer: item,
                }));
                callback(options);
              } catch (err) {
                console.error("Error searching customers:", err);
                if (
                  (err.response?.data &&
                    err.response.data?.err?.name === "TokenExpiredError") ||
                  err.response?.data?.message === "Unauthorized"
                ) {
                  sessionStorage.clear();
                  navigate("/cri-crm");
                }
                callback([]);
              }
            }}
            onChange={(selected) => {
              if (selected && selected.customer) {
                clearFom();
                setSelectCm(selected.customer);
                sessionStorage.setItem("savedMrn", JSON.stringify(selected.customer.mrn));
                toggleSearchModal();
              }
            }}
            placeholder="Type patient name, MRN or mobile number..."
            className="shadow-sm rounded-3"
          />
        </Modal.Body>
      </Modal>

      {/* Patient Allocation / History Modal */}
      <Modal show={modal} onHide={toggle} size="lg" centered>
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="fw-bold">{mHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {mHeader === "Patient List" ? (
            <div>
              {customerData && customerData.length > 0 ? (
                customerData.map((item, id) => (
                  <Card key={id} className="border shadow-sm mb-3">
                    <Card.Header className="bg-light d-flex justify-content-between align-items-center py-2 px-3">
                      <div>
                        <h6 className="mb-0 fw-bold text-dark">{item.fname} {item.sname}</h6>
                        <small className="text-muted">{item.mrn}</small>
                      </div>
                      <Button
                        variant="primary"
                        size="sm"
                        className="px-3 rounded-pill"
                        onClick={() => {
                          clearFom();
                          selectCmHandler(item);
                        }}
                      >
                        Select Profile
                      </Button>
                    </Card.Header>
                    <Card.Body className="py-2 px-3 small text-secondary">
                      <Row className="g-2">
                        <Col xs={6}><strong>sex:</strong> {item.sex || "—"}</Col>
                        <Col xs={6}><strong>DOB:</strong> {item.dob || "—"}</Col>
                        <Col xs={12}><strong>Treatment:</strong> {item.treatmenttype || "—"}</Col>
                        <Col xs={12}><strong>Past Prescription:</strong> {item.pastPrescription || "—"}</Col>
                        <Col xs={12} className="text-danger"><strong>Drug Allergies:</strong> {item.reactionAlergies || "None Reported"}</Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))
              ) : (
                <div className="text-center py-4 text-muted">No appointments found for selected date.</div>
              )}
            </div>
          ) : isLoadingHistory ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
        <div>
  {customerHistory && customerHistory.length > 0 ? (
    [...customerHistory]
      .sort((a, b) => new Date(b.fullDate) - new Date(a.fullDate))
      .map((item, id) => (
        <Card key={id} className="border shadow-sm mb-3">
          <Card.Header className="bg-light d-flex justify-content-between align-items-center py-2 px-3">
            <div>
              <span className="text-muted small d-block">Consultation Date</span>
              <strong className="text-primary">
                {formatDisplayDate(item.date)} @ {formatDisplayTime(item.fullDate)}
              </strong>
            </div>
            
            {/* Action Buttons Group */}
            <div className="d-flex align-items-center gap-2">
              <PrescriptionActions
                prescription={item}
                branch={branch}
                token={token}
                branchData={branchData}
                address={address}
                contactNo={item.contactno || selectedCm?.contactno}
                size="sm"
                className="rounded-pill bg-white px-3"
              />
              <ReactToPrint
                onBeforeGetContent={() => {
                  setPrintData(
                    buildPrintPayload({
                      ...item,
                      doctorName: item.doctorName || doctorName,
                      username: item.doctorName || doctorName,
                    })
                  );
                  return new Promise((resolve) => setTimeout(resolve, 100));
                }}
                trigger={() => (
                  <Button variant="outline-secondary" size="sm" className="d-flex align-items-center gap-1 rounded-pill bg-white px-3">
                    <Printer size={14} /> Print Record
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </div>
          </Card.Header>
          <Card.Body className="p-3 small">
            <p className="mb-1"><strong>Diagnosis:</strong> {item.diagnosis || "—"}</p>
            <p className="mb-1"><strong>Prescription:</strong> {item.prescription || "—"}</p>
            <p className="mb-0"><strong>Advice:</strong> {item.specialAdvice || "—"}</p>
          </Card.Body>
        </Card>
      ))
  ) : (
    <div className="text-center py-4 text-muted">No historical records found for this patient.</div>
  )}
</div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Treatment;